import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'
import { connect } from 'react-redux'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import Tabs from '../../../../../../../../../components/Tabs'
import GdprIcon from '../../../../../../../../../components/GdprIcon'

import Debts from './components/Debts'
import Insolvency from './components/Insolvency'
import Liquidation from './components/Liquidation'
import PaymentOrders from './components/PaymentOrders'
import RiskyTaxSubject from './components/RiskyTaxSubject'
import Execution from './components/Execution'
import { negativeEventsLoadDistraintsHistory } from './actions'
import { LOCALE_PREFIX } from './constants'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@connect(null, { loadDistraintsHistory: negativeEventsLoadDistraintsHistory })
@injectIntl
export default class NegativeEvents extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        scrollRefs: PropTypes.object,
        scrollTo: PropTypes.func.isRequired,
    }

    componentDidMount() {
        const { loadDistraintsHistory, id, module, block } = this.props
        // loading distraints history now because od PDF export - need to send the history via export settings
        loadDistraintsHistory(id, module, block)
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.locale !== nextProps.locale) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const {
            id,
            module,
            block,
            level,
            data,
            intl: { formatMessage },
            locale,
            customData,
            scrollRefs,
            scrollTo,
        } = this.props

        if (_.isEmpty(data)) return null

        return (
            <div className={cx('block-negative-events')}>
                <div className={'gdrp-container'}>
                    <GdprIcon id={id} block={block}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.gdprTooltip`}
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                acz: (chunks) => (
                                    <a
                                        href="mailto:podpora.cz@dnb.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        href="mailto:podpora.sk@dnb.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }}
                        />
                    </GdprIcon>
                </div>
                <Tabs
                    level={level}
                    id={`negative-events-tabs-${id}`}
                    key={`negative-events-tabs-${id}`}
                    tabs={[
                        {
                            // INSOLVENCY
                            title: formatMessage({ id: `${LOCALE_PREFIX}.insolvency` }),
                            content: (
                                <Insolvency
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    locked={_.isNil(data?.insolvency?.active) && _.isNil(data?.insolvency?.total)}
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'insolvency.active', 0),
                                    color: _.get(data, 'insolvency.active', 0) > 0 ? '#DC0000' : '#4D4D4D',
                                },
                                right: {
                                    count: _.get(data, 'insolvency.total', 0),
                                },
                            },
                            locked: _.isNil(data?.insolvency?.active) && _.isNil(data?.insolvency?.total),
                        },
                        {
                            // LIQUIDATION
                            title: formatMessage({ id: `${LOCALE_PREFIX}.liquidation` }),
                            content: (
                                <Liquidation
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    scrollRefs={scrollRefs}
                                    scrollTo={scrollTo}
                                    locked={_.isNil(data?.liquidation?.active) && _.isNil(data?.liquidation?.total)}
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'liquidation.active', 0),
                                    color: _.get(data, 'liquidation.active', 0) > 0 ? '#DC0000' : '#4D4D4D',
                                },
                                right: {
                                    count: _.get(data, 'liquidation.total', 0),
                                },
                            },
                            locked: _.isNil(data?.liquidation?.active) && _.isNil(data?.liquidation?.total),
                        },
                        {
                            // RISKY TAX SUBJECT
                            title: formatMessage({ id: `${LOCALE_PREFIX}.riskyTaxSubject` }),
                            content: (
                                <RiskyTaxSubject
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    locked={
                                        _.isNil(data?.riskyTaxSubject?.active) && _.isNil(data?.riskyTaxSubject?.total)
                                    }
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'riskyTaxSubject.active', 0),
                                    color: _.get(data, 'riskyTaxSubject.active', 0) > 0 ? '#DC0000' : '#4D4D4D',
                                },
                                right: {
                                    count: _.get(data, 'riskyTaxSubject.total', 0),
                                },
                            },
                            locked: _.isNil(data?.riskyTaxSubject?.active) && _.isNil(data?.riskyTaxSubject?.total),
                        },
                        {
                            // EXECUTION
                            title: formatMessage({ id: `${LOCALE_PREFIX}.execution` }),
                            content: (
                                <Execution
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    locked={_.isNil(data?.execution?.active) && _.isNil(data?.execution?.total)}
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'execution.active', 0),
                                    color: _.get(data, 'execution.active', 0) > 0 ? '#DC0000' : '#4D4D4D',
                                },
                                right: {
                                    count: _.get(data, 'execution.total', 0),
                                },
                            },
                            locked: _.isNil(data?.execution?.active) && _.isNil(data?.execution?.total),
                        },
                        {
                            // DEBTS
                            title: formatMessage({ id: `${LOCALE_PREFIX}.debts` }),
                            content: (
                                <Debts
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    summaryData={data}
                                    customData={customData}
                                    locked={_.isNil(data?.debts?.active) && _.isNil(data?.debts?.total)}
                                />
                            ),
                            counter: {
                                left: {
                                    count: _.get(data, 'debts.active', 0),
                                    color: _.get(data, 'debts.active', 0) > 0 ? '#DC0000' : '#4D4D4D',
                                },
                                right: {
                                    count: _.get(data, 'debts.total', 0),
                                },
                            },
                            locked: _.isNil(data?.debts?.active) && _.isNil(data?.debts?.total),
                        },
                        {
                            // PAYMENT ORDERS
                            title: formatMessage({ id: `${LOCALE_PREFIX}.paymentOrders` }),
                            content: (
                                <PaymentOrders
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    locale={locale}
                                    customData={customData}
                                    locked={_.isNil(data?.paymentOrders?.active)}
                                />
                            ),
                            subtitle: formatMessage({ id: `${LOCALE_PREFIX}.entries` }),
                            counter: {
                                left: {
                                    count: _.get(data, 'paymentOrders.active', 0),
                                },
                            },
                            locked: _.isNil(data?.paymentOrders?.active),
                        },
                    ]}
                />
            </div>
        )
    }
}
